module.exports = __webpack_public_path__ + "media/images/share-79eaec2aba17886e820b6a99fecb02f8.svg";